/**
 * @fileoverview Modal component for viewing and editing user details
 * Uses DmsDetailModal for consistent behavior across the application
 */
import React from "react";
import PropTypes from "prop-types";
import { intl } from "dmsbasereact";
import { DmsDetailModal } from "../DmsDetailModal";
import { ViewModeContent } from "./ViewModeContent";
import { EditModeContent } from "./EditModeContent";
import { prepareEditFormData, buildUpdatePayload } from "./payloadBuilders";

/**
 * Modal for viewing and editing user details
 */
export const UserDetailModal = ({
  open,
  onClose,
  user = null,
  loading = false,
  availableRoles = [],
  onSave,
  onUserUpdated = null,
  userType = null}) => {
  return (
    <DmsDetailModal
      open={open}
      onClose={onClose}
      data={user}
      loading={loading}
      title={{
        view: intl.get("UserDetails").d("User Details"),
        edit: intl.get("EditUserDetails").d("Edit User Details"),
      }}
      viewContent={ViewModeContent}
      editContent={EditModeContent}
      prepareFormData={prepareEditFormData}
      buildPayload={buildUpdatePayload}
      onSave={onSave}
      onDataUpdated={onUserUpdated}
      editContentProps={{ availableRoles, userType }}
      confirmMessage={intl.get("ConfirmSaveUserMessage").d("Are you sure you want to save the user changes?")}
    />
  );
};

UserDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object,
  loading: PropTypes.bool,
  availableRoles: PropTypes.array,
  onSave: PropTypes.func.isRequired,
  onUserUpdated: PropTypes.func,
  userType: PropTypes.string,
};

